<template>
  <div class="container" id="container">
    <div id="dashboard" >
      <!-- Dashboard header -->
      <div class="dashboard__header mb-4 row no-gutters">

        <!-- Dashboard Title -->
        <div class="col-sm-12 col-md-12 dashboard__header--col" ref="topTitle">
          <div>
            <svg class="dashboard__header--icon h-100 display-inline-block" width="28" height="23" viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.8393 0.5625C6.19596 0.5625 0 6.8584 0 14.625C0 17.2031 0.684756 19.6182 1.87695 21.6953C2.14653 22.165 2.66022 22.4375 3.19553 22.4375H24.483C25.0184 22.4375 25.532 22.165 25.8016 21.6953C26.9938 19.6182 27.6786 17.2031 27.6786 14.625C27.6786 6.8584 21.4826 0.5625 13.8393 0.5625ZM21.6815 9.07861L16.4654 16.1455C16.7446 16.6157 16.9147 17.1606 16.9147 17.75C16.9147 18.3223 16.7523 18.8511 16.488 19.3125H11.1906C10.9263 18.8511 10.7639 18.3223 10.7639 17.75C10.7639 16.0239 12.1406 14.625 13.8393 14.625C14.1108 14.625 14.3688 14.6719 14.6197 14.7393L19.8363 7.67139C20.2198 7.15576 20.9415 7.05029 21.4514 7.43701C21.9603 7.82568 22.064 8.56055 21.6815 9.07861Z" fill="#2B4D75"/></svg>
            <h1 class="dashboard__header--title m-0 header">Errors</h1>

          </div>
        </div>

      </div>


      <!-- Table -->
      <div id="products-table">
        <s-card class="products-table__card border-top-0 p-0">
          <s-card-body class="product-table__table p-0">
              <div class="product-table__table-container" @scroll="getScrollPos">
                  <div class="div-shadow-left" v-if="!hideShadows && scrollIn && scrollIn !== 'left' && errorsList && errorsList.length"></div>
                  <!-- errorsList && errorsList.length &&  -->
                  <!-- style="width: 1280px;" -->
                  <table class="product-table__table--table"  id="myTable">
                      <thead class="product-table__table--header border-0 p-0 mb-4">
                          <!-- Error ID -->
                          <td class="text-truncate product-table__table--header-id">
                              <span>ID</span>
                          </td>
                          <!-- Error Name -->
                          <td class="text-truncate product-table__table--header-domain">
                              <span>Error</span>
                          </td>
                          <!-- Error Faq Url -->
                          <td class="text-truncate product-table__table--header-domain">
                              <span>Faq Url</span>
                          </td>
                          <!-- Meaningful Message -->
                          <td class="text-truncate product-table__table--header-domain">
                              <span>Meaningful Message</span>
                          </td>
                          <!-- count -->
                          <td class="text-truncate product-table__table--header-id">
                              <span>Total</span>
                          </td>
                          <!--  Add Meaningful Message -->
                          <td class="text-truncate product-table__table--header-joined">
                              <span >Edit</span>
                          </td>
                      </thead>
                      <tbody class="product-table__table--body">
                          <tr class="w-100 display-table-cell" v-if="loading">
                              <s-loader :type="'scalify'" class="my-3" style="left:calc(50% - 42px);position:relative;"></s-loader>
                          </tr>
                          <tr class="w-100 display-table-cell" v-if="!loading && (errorsList == null || errorsList.length == 0)">
                              <p class="my-3 position-relative font-weight-sbold" style="left:40%;">No Results</p>
                          </tr>
                          <div v-if="!loading && errorsList && errorsList.length > 0">
                            <tr  v-show="!loading" v-for="(error, errorIndex) in errorsList" :key="errorIndex" class="product-table__table--row w-100">
                                <!-- ID -->
                                <td  class="display-table-cell product-table__table--body-id">
                                  <p class="text-truncate">{{error.id}}</p>
                                </td>
                                <!-- Name -->
                                <td :tooltip-position="errorIndex==0?'right':'top'" :tooltip="JSON.stringify(error.error && error.error.error_user_msg && error.error.error_user_msg.length ? error.error.error_user_msg : error.error && error.error.message ? error.error.message : '')" class="display-table-cell product-table__table--body-domain">
                                  <p  class="text-truncate">{{error.error && error.error.error_user_msg && error.error.error_user_msg.length ? error.error.error_user_msg : error.error && error.error.message ? error.error.message : ''}}</p>
                                </td>
                                <!-- faq_url -->
                                <td :tooltip-position="errorIndex==0?'right':'top'" :tooltip="error.faq_url ? error.faq_url : ''" class="display-table-cell product-table__table--body-domain">
                                  <p  class="text-truncate">{{error.faq_url}}</p>
                                </td>
                                <!-- Meaningful Message -->
                                <td :tooltip-position="errorIndex==0?'right':'top'" :tooltip="error.meaningful_message ? error.meaningful_message : ''" class="display-table-cell product-table__table--body-domain">
                                  <p  class="text-truncate">{{error.meaningful_message}}</p>
                                </td>
                                <!--  Count -->
                                <td class="display-table-cell product-table__table--body-id">
                                    <p  class="text-truncate">{{error.count}}</p>
                                </td>
                                <!--  Add Meaningful Message -->
                                <td class="display-table-cell product-table__table--body-joined">
                                    <button class="btn btn--primary" @click="editError(errorIndex)" >Edit</button>
                                </td>
                            </tr>
                          </div>

                      </tbody>
                  </table>
                  <div class="div-shadow-right" v-if="!hideShadows && scrollIn && scrollIn !== 'right' && ((errorsList && errorsList.length))"></div>
              </div>
          </s-card-body>
          <s-card-body v-if="errorsList && errorsList.length && loadMoreErrors && !loading" class="p-0 product-table__load-more text-center">
              <button v-if="!loadingLoadMore" class="btn btn--white" @click="loadMoreAccountsDetails()">Load More</button>
              <s-loader :type="'scalify'" v-else></s-loader>
          </s-card-body>
        </s-card>
      </div>
      <!-- Edit Error -->
      <div v-if="isEditError" style="background: rgba(13, 35, 62, 0.94); height: 100%; width: 100%; position: fixed; top: 0; left: 0;z-index: 13;">
        <s-card style="width: 90%; position: absolute; transform: translate(-50%,-50%); left: 50%; top: 50%;">
          <s-card-header class="font-weight-bold">Add Meaningful Message</s-card-header>
          <s-card-body class="p-3">
            <div class="row mb-2 no-gutters" style="margin: 0 -10px;">
              <div class="col-2 font-weight-bold" style="padding: 0 10px;"> Your Error: </div>
              <div class="col-10 text-danger" style="padding: 0 10px;">{{currentError.error && currentError.error.error_user_msg && currentError.error.error_user_msg.length ? currentError.error.error_user_msg : currentError.error && currentError.error.message ? currentError.error.message : '' }}</div>
            </div>

            <div class="row mb-2 no-gutters" style="margin: 0 -10px;">
              <div class="col-2 font-weight-bold" style="padding: 0 10px;"> FAQ Url: </div>
              <div class="col-10 text-danger" style="padding: 0 10px;">
                <s-input v-model="faqUrl"  fieldFor="settings"></s-input>
              </div>
            </div>

            <div class="row mb-2 no-gutters" style="margin: 0 -10px;">
              <div class="col-2 font-weight-bold" style="padding: 0 10px;"> Meaningful Message: </div>
              <div class="col-10 text-danger" style="padding: 0 10px;">
                <s-input v-model="meaningful_message"  fieldFor="settings"></s-input>
              </div>
            </div>
          </s-card-body>
          <s-card-footer class="text-right">
            <button @click="isEditError = false" class="btn btn--white">Cancel</button>
            <button v-if="!loadingSaveError" @click="saveError()" class="btn btn--primary ml-2">Save</button>
            <button v-else class="btn btn--primary ml-2 disabled">
              <s-loader :isWhite="true"></s-loader>
            </button>
          </s-card-footer>
        </s-card>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'Errors',

  components:{
  },

  props: {},

  computed:{
  },

  data(){
    return{
      isEditError: false,
      errorsList: [],
      showColumns: false,
      loading:false,
      hideShadows:false,
      scrollIn:"left",
      loadMoreErrors: true,
      loadingLoadMore: false,
      currentPage: 1,
      currentError: null,
      faqUrl: "",
      meaningful_message: "",
      loadingSaveError: false
    }
  },

  methods:{
    editError(index){
      this.isEditError = true;
      this.currentError = this.errorsList[index];
      if (this.currentError) {

        if (this.currentError.faq_url) {
          this.faqUrl = this.currentError.faq_url
        }
        if (this.currentError.faq_url) {
          this.meaningful_message = this.currentError.meaningful_message
        }
      }
    },
    async saveError(){

      try {

        this.loadingSaveError = true;
        let saveError = await this.saveMeaningfulMessage(this.currentError.id, this.faqUrl, this.meaningful_message)
        if (saveError && saveError.status == "success") {
          let indexError = this.errorsList.findIndex((element) => element.id == this.currentError.id)
          this.errorsList[indexError].faq_url = this.faqUrl;
          this.errorsList[indexError].meaningful_message = this.meaningful_message;
          this.currentError = null;
          this.isEditError = false;
        }
        this.loadingSaveError = false;

      } catch (error) {
        this.loadingSaveError = false;
      }


    },
    getScrollPos ({ target: { scrollLeft ,clientWidth, scrollWidth }}) {
      var scroll = "left"
      if(scrollLeft == 0){
          scroll = "left"
      }
      else if(scrollLeft+clientWidth < scrollWidth){
          scroll = "middle"
      }
      if(scrollLeft+clientWidth >= scrollWidth){
          scroll = "right"
      }
      this.scrollIn = scroll
    },
    updateTableWidth(){
      this.$nextTick(()=>{
        var x = document.getElementById("myTable")
        if(x){
            var items = x.children[0].children
            var w = 0
            for(var i=0;i<items.length;i++){
                w = w + items[i].clientWidth
            }
            if(parseInt(w) < 1110){
                this.hideShadows = true
            }
            else{
                this.hideShadows = false
            }
            x.style.width=w+'px'
            this.$forceUpdate()
        }
      })
    },
    async loadMoreAccountsDetails(){
      try {

        this.loadingLoadMore = true;
        this.currentPage = parseInt(this.currentPage) + 1;
        let errors = await this.errorsTable(this.currentPage)
        if (errors && errors.data) {
          this.errorsList = this.errorsList.concat(errors.data);
          this.currentPage = errors.current_page;
          if (errors && errors.data && errors.data.length >= 25) {
            this.loadMoreErrors = true;
          }else{
            this.loadMoreErrors = false;
          }
        }else{
          this.loadMoreErrors = false;
        }
        this.loadingLoadMore = false;
      } catch (error) {
        this.loadingLoadMore = false;
      }
    }

  },

  async created(){

  },

  watch:{

  },

  async mounted(){

    this.loading = true
    const errors = await this.errorsTable(this.currentPage);
    if (errors && errors.data) {
      this.errorsList = errors.data;
      if (errors && errors.data && errors.data.length >= 25) {
        this.loadMoreErrors = true;
      }else{
        this.loadMoreErrors = false;
      }
    }
    this.loading = false

  }


}
</script>

<style scoped>

</style>
